import axios from "axios";
import { PPD_OVERVIEW, SET_ERROR } from "../../types";

export const getPPDOverview = params => {
    return async dispatch => {
        await axios.get('api/ppd/ppd-overview', { params }).then(res => {
            dispatch({
                type: PPD_OVERVIEW,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}